import {Col,  Form,  Input,  Radio, Row } from 'antd';
import React, { Fragment, useState } from 'react';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import CustomEmpty from '../../../../../../../components/custom-empty';
import EnhancedModal from '../../../../../../../components/enhanced-modal';
import FormList from '../../../../../../../components/form-list';
import ItemList from '../../../../../../../components/item-list';
import Selector from '../../../../../../../components/selector';
import { DataLanguageConsumer } from '../../../../../../../contexts/DataLanguage';
import { GUTTER_MD, MARGIN_MD, MODAL_WIDTH_LG, SPAN_ONE_QUARTER, SPAN_TWO_QUARTERS  } from '../../../../../../../styles/constants';
import { getArtefactTripletFromString } from '../../../../../../../utils/sdmxJson';
import { componentIsMandatory, getComponentsFromCubeComponents, getInitialBlock } from '../../../utils';
import CalculatedBlock from './CalculatedBlock';

const mapPropsToFields = ({componentValueDefinition}) => ({
  defaultValueText: Form.createFormField({value: (componentValueDefinition.mappingValue.calculatedValue.defaultValue.text || "").length > 0 
        ? componentValueDefinition.mappingValue.calculatedValue.defaultValue.text 
        : null}),
});


const CalculatedComponent = ({
    t,
    form,
    appLanguage,
    componentValueDefinition,
    cubeComponents,
    codelistCode,
    componentCodelistCodesItemsPage,
    componentCodelistCodesItemsCount,
    fetchCodelistCodesItemsPage,
    onComponentValueDefinitionValueSet,
  }) => {    

    const components = getComponentsFromCubeComponents(cubeComponents, [componentValueDefinition.cubeComponent.name], false);
    const blocksNumber = (componentValueDefinition.mappingValue.calculatedValue.blocks || []).length;
    
    const codelistTriplet = codelistCode ? getArtefactTripletFromString(codelistCode) : null;
    
    const isMandatory = componentIsMandatory(componentValueDefinition.cubeComponent);

    const [isCodeSelectorVisible, setCodeSelectorVisible] = useState(false);

    const onComponentValueSet = (value) => {
      onComponentValueDefinitionValueSet(value);
      setCodeSelectorVisible(false);
    }

    return (
      <Fragment>
        {blocksNumber > 0 
          ? <Fragment>
              <Row style={{marginBottom: MARGIN_MD}}>
                <Col>
                  <Radio.Group size="small"
                    value={componentValueDefinition.mappingValue.calculatedValue.logicalOperator}
                    onChange={({target}) => onComponentValueDefinitionValueSet({logicalOperator:target.value})}>      
                    {['AND', 'OR'].map(op =>
                      <Radio.Button key={op} value={op}>{op}</Radio.Button>)
                    }
                  </Radio.Group>
                </Col>
              </Row>
              <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}} >
                <Col >
                  <FormList
                    notCollapsable
                    values={componentValueDefinition.mappingValue.calculatedValue.blocks}
                    Component={CalculatedBlock}
                    componentProps={
                      {
                        components:components,
                        appLanguage:appLanguage,
                        componentValueDefinition:componentValueDefinition,
                        codelistCode: codelistCode,
                        onComponentValueDefinitionValueSet:onComponentValueDefinitionValueSet,
                        componentCodelistCodesItemsPage:componentCodelistCodesItemsPage,
                        componentCodelistCodesItemsCount:componentCodelistCodesItemsCount,
                        fetchCodelistCodesItemsPage:fetchCodelistCodesItemsPage
                      }
                    }
                    newItem={getInitialBlock(components[0].name, blocksNumber)}
                    minItems={1}
                    addItemLabel={t('components.whereConditionsForm.addBlockButton')}
                    removeItemLabel={t('components.whereConditionsForm.block.removeButton')}
                    onChange={values => onComponentValueDefinitionValueSet({blocks:values})}
                  /> 
                </Col>            
              </Row>
              <Row gutter={GUTTER_MD}>
              <Col span={SPAN_ONE_QUARTER}>
                <Fragment>
                  {isMandatory && (
                    <span
                      style={{display:"inline-block", color: "#f5222d", marginRight: "4px", fonFamily: "SimSun", lineHeight: 1, fontSize: "14px"}}
                    >
                      *
                    </span>
                  )}
                  <span
                    style={{fontWeight:"bold"}}
                  >
                    {t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.calculated.default.title') + ":"}
                  </span>
                </Fragment>
                </Col>
                <Col span={SPAN_ONE_QUARTER}>
                  {`${componentValueDefinition.cubeComponent.name}=`}
                </Col>
                <Col span={SPAN_TWO_QUARTERS}>
                  {form.getFieldDecorator("defaultValueText")( 
                  (codelistCode || "").length > 0 ? 
                    (
                      <Selector
                        onSelect={() => setCodeSelectorVisible(true)}
                        onReset={() => onComponentValueDefinitionValueSet({defaultValue:{text:null, isMandatory:isMandatory}})}                        
                      />
                    )
                    : (
                      
                      <Input 
                        title={form.getFieldValue("defaultValueText")}
                        onChange={({target}) =>
                            onComponentValueDefinitionValueSet({defaultValue:{text:target.value, isMandatory:isMandatory}})} 
                      />
                    )            
                  )}
                </Col>
              </Row>
            
              <EnhancedModal
                visible={isCodeSelectorVisible}
                onCancel={() => setCodeSelectorVisible(false)}
                title={t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.valueSelector.title')}
                width={MODAL_WIDTH_LG}        
                withDataLanguageSelector
              >
                <DataLanguageConsumer>   
                  {dataLanguage => {
                    const language = dataLanguage || appLanguage;
                    return (
                      <ItemList
                        data={componentCodelistCodesItemsPage || null}
                        rowCount={componentCodelistCodesItemsCount}
                        isPaginated
                        onRowClick={item => onComponentValueSet({defaultValue:{text:item.id, isMandatory:isMandatory}})}     
                        onChange={
                          ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) =>
                          fetchCodelistCodesItemsPage({
                              codelistTriplet,
                              language,
                              pageNum,
                              pageSize,
                              searchText,
                              filters,
                              sortCol,
                              sortByDesc
                            })
                        }
                      />
                    );
                  }}     
                </DataLanguageConsumer>
              </EnhancedModal> 
            </Fragment>                             
          : <CustomEmpty/>  
        }
      </Fragment>            
    );
  }      
     

export default compose(
  translate(),
  Form.create({mapPropsToFields})
)(CalculatedComponent);
